import { Skeleton } from "@/components/ui/skeleton";

export function DealDetailSkeleton() {
  return (
    <div className="flex h-full flex-col overflow-hidden bg-background">
      {/* Breadcrumb Header */}
      <header className="flex h-12 items-center border-b border-border bg-card px-6">
        <div className="flex items-center gap-2">
          <Skeleton className="h-4 w-16" />
          <Skeleton className="h-4 w-4" />
          <Skeleton className="h-4 w-24" />
        </div>
      </header>

      {/* Deal Header */}
      <div className="border-b border-border bg-card px-6 py-4">
        <div className="flex items-start justify-between gap-6">
          <div className="min-w-0 flex-1">
            {/* Status Badge */}
            <div className="flex items-center gap-1.5">
              <Skeleton className="h-2 w-2 rounded-full" />
              <Skeleton className="h-3 w-16" />
            </div>
            {/* Title */}
            <Skeleton className="mt-2 h-8 w-64" />
            {/* Metadata */}
            <div className="mt-2 flex items-center gap-2">
              <Skeleton className="h-3 w-20" />
              <Skeleton className="h-3 w-2 rounded-full" />
              <Skeleton className="h-3 w-24" />
              <Skeleton className="h-3 w-2 rounded-full" />
              <Skeleton className="h-3 w-32" />
            </div>
          </div>
          {/* Actions */}
          <div className="flex shrink-0 items-center gap-1.5 pt-1">
            <Skeleton className="h-[30px] w-24 rounded-lg" />
            <Skeleton className="h-[30px] w-[30px] rounded-lg" />
          </div>
        </div>
      </div>

      {/* Tab Bar */}
      <div className="flex items-center justify-between border-b border-border bg-card px-6">
        <div className="flex items-center gap-4 overflow-x-auto py-3">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="flex items-center gap-1.5">
              <Skeleton className="h-3.5 w-3.5" />
              <Skeleton className="h-4 w-12" />
            </div>
          ))}
        </div>
        <Skeleton className="h-[30px] w-20 rounded-lg" />
      </div>

      {/* Main Content */}
      <div className="flex-1 overflow-y-auto">
        <div className="mx-auto max-w-2xl space-y-4 p-6">
          {/* Legend Row */}
          <div className="flex items-center justify-between">
            <div className="flex gap-4">
              {[1, 2, 3].map((i) => (
                <div key={i} className="flex items-center gap-1.5">
                  <Skeleton className="h-1.5 w-1.5 rounded-full" />
                  <Skeleton className="h-3 w-12" />
                </div>
              ))}
            </div>
            <div className="flex items-center gap-3">
              <Skeleton className="h-3 w-24" />
              <Skeleton className="h-6 w-20 rounded-md" />
            </div>
          </div>

          {/* Sections */}
          {[1, 2].map((section) => (
            <div key={section} className="overflow-hidden rounded-lg border border-border bg-card">
              {/* Section Header */}
              <div className="border-b border-border px-4 py-2.5">
                <Skeleton className="h-3 w-20" />
              </div>
              {/* Section Fields */}
              <div className="divide-y divide-border/60">
                {[1, 2, 3, 4].map((field) => (
                  <div key={field} className="flex items-center gap-4 px-4 py-3">
                    <Skeleton className="h-4 w-36 shrink-0" />
                    <Skeleton className="h-4 flex-1" />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
